import { festivalDay } from '../lib/formatDate'
import { useClockSelector } from './useClockSelector'

/**
 * The festival day we're currently on for an event with day cutoff `cutoff`
 * (`eventDayCutoff()`), reactive to the admin clock override and to the day
 * rolling over. Unlike `useNow`, this only re-renders when the day *string*
 * changes, so a page can follow the festival day without re-rendering every tick.
 */
export function useCurrentFestivalDay(cutoff: number): string {
  return useClockSelector(now => festivalDay(cutoff, now))
}
